import { Component, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA, MatDialogConfig, MatPaginator } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import { AdminProjectModalComponent } from '../../client-lead/admin-project-modal/admin-project-modal.component';
import { ClientProjectBrochuerModalComponent } from '../../client-project/client-project-brochuer-modal/client-project-brochuer-modal.component';
import { ClientProjectCloneComponent } from '../../client-project/client-project-clone/client-project-clone.component';
import { ClientProjectDeleteModalComponent } from '../../client-project/client-project-delete-modal/client-project-delete-modal.component';
import { ClientProjectInfoModalComponent } from '../../client-project/client-project-info-modal/client-project-info-modal.component';
import { ClientProjectQualifiedModalComponent } from '../../client-project/client-project-qualified-modal/client-project-qualified-modal.component';
import { ClientProjectStatsModalComponent } from '../../client-project/client-project-stats-modal/client-project-stats-modal.component';
import { ClientProjectWhatsappProfileDeleteComponent } from '../../client-project/client-project-whatsapp-profile-delete/client-project-whatsapp-profile-delete.component';
import { LeadSendMiModalComponent } from '../../client-project/lead-send-mi-modal/lead-send-mi-modal.component';
import { ProjectAllStatusModalComponent } from '../../client-project/project-all-status-modal/project-all-status-modal.component';
import { ProjectByClientComponent } from '../../client-project/project-by-client/project-by-client.component';
import { ProjectEmailNotifyModalComponent } from '../../client-project/project-email-notify-modal/project-email-notify-modal.component';
import { ProjectFeedbackModalComponent } from '../../client-project/project-feedback-modal/project-feedback-modal.component';
import { ProjectMediaPlanComponent } from '../../client-project/project-media-plan/project-media-plan.component';
import { ProjectStatusModalComponent } from '../../client-project/project-status-modal/project-status-modal.component';
import { ProjectUploadAvatarModalComponent } from '../../client-project/project-upload-avatar-modal/project-upload-avatar-modal.component';
import { UserListModalComponent } from '../../client-project/user-list-modal/user-list-modal.component';
import { RegistrationCreateModalComponent } from '../../registration-list/registration-create-modal/registration-create-modal.component';
import { WhatsappProfileModalComponent } from '../../whatsapp-profile-modal/whatsapp-profile-modal.component';
import { CampaignFilterModalComponent } from '../campaign-filter-modal/campaign-filter-modal.component';
import { SaleCampaignCreateModalComponent } from '../sale-campaign-create-modal/sale-campaign-create-modal.component';
import { SaleCampaignEditModalComponent } from '../sale-campaign-edit-modal/sale-campaign-edit-modal.component';
import { SaleCampaignClientCreateModalComponent } from '../sale-campaign-client-create-modal/sale-campaign-client-create-modal.component';
import { SaleCampaignProjectCreateModalComponent } from '../sale-campaign-project-create-modal/sale-campaign-project-create-modal.component';
import { CampaignStatusComponent } from '../../campaign/campaign-status/campaign-status.component';
import { AddLeadDeliveredComponent } from '../add-lead-delivered/add-lead-delivered.component';
import { AddBudgetComponent } from '../add-budget/add-budget.component';
import { AddAmountSpentComponent } from '../add-amount-spent/add-amount-spent.component';
import { LeadDeliveryListComponent } from '../lead-delivery-list/lead-delivery-list.component';
import { AmountSpentListComponent } from '../amount-spent-list/amount-spent-list.component';
import { BudgetListComponent } from '../budget-list/budget-list.component';
import { AddFeedbackComponent } from '../add-feedback/add-feedback.component';
import { FeedbackListModalComponent } from '../feedback-list-modal/feedback-list-modal.component';
import { RaiseEscalationComponent } from '../raise-escalation/raise-escalation.component';
import { EscalationStatusModalComponent } from '../escalation-status-modal/escalation-status-modal.component';
import { VendorAssignModelComponent } from '../../client-list/vendor-assign-model/vendor-assign-model.component';
import { ProjectListModalComponent } from '../project-list-modal/project-list-modal.component';


@Component({
  selector: 'app-sale-campaign',
  templateUrl: './sale-campaign.component.html',
  styleUrls: ['./sale-campaign.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SaleCampaignComponent implements OnInit {

  authToken: any = localStorage.getItem("token")
  userInfo: any = JSON.parse(localStorage.getItem("userInfo"))
  showComponentLoader: boolean = false;

  project: any = {
    campaigns: [],
    pagination: {}
  }

  elasticSearch: any = ""
  statusSpinner: boolean = false;

  saleCampaignCreateModalComponent: MatDialogRef<SaleCampaignCreateModalComponent>;
  saleCampaignProjectCreateModalComponent: MatDialogRef<SaleCampaignProjectCreateModalComponent>;
  saleCampaignEditModalComponent: MatDialogRef<SaleCampaignEditModalComponent>
  saleCampaignClientCreateModalComponent: MatDialogRef<SaleCampaignClientCreateModalComponent>
  campaignFilterModalComponent: MatDialogRef<CampaignFilterModalComponent>
  campaignStatusComponent: MatDialogRef<CampaignStatusComponent>;

  addLeadDeliveredComponent: MatDialogRef<AddLeadDeliveredComponent>;
  leadDeliveryListComponent: MatDialogRef<LeadDeliveryListComponent>;

  addBudgetComponent: MatDialogRef<AddBudgetComponent>;
  amountSpentListComponent: MatDialogRef<AmountSpentListComponent>;

  addAmountSpentComponent: MatDialogRef<AddAmountSpentComponent>;
  budgetListComponent: MatDialogRef<BudgetListComponent>;

  addFeedbackComponent: MatDialogRef<AddFeedbackComponent>;
  feedbackListModalComponent: MatDialogRef<FeedbackListModalComponent>;

  raiseEscalationComponent: MatDialogRef<RaiseEscalationComponent>;
  escalationStatusModalComponent: MatDialogRef<EscalationStatusModalComponent>;

  vendorAssignModelComponent: MatDialogRef<VendorAssignModelComponent>;

  projectListModalComponent: MatDialogRef<ProjectListModalComponent>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  pageIndex: number = 0;
  pageSize: number = 100;

  lenCount: any = 0

  url = "";

  campaign_status: string = "";
  finance_approved: any = '';
  campaign_type: string = "";
  client_type: string = "";
  created_by: string = "";
  marketing_manager: string = "";
  account_manager: string = "";
  assigned_user: string = null;
  saleCity: string = null;
  sale_person: string = "";
  createdAt: any = "";
  assignedToMe: boolean = false;

  allIsActive: boolean = true;
  initialIsActive: boolean = false;
  inprogressIsActive: boolean = false;
  onholdlIsActive: boolean = false;
  liveIsActive: boolean = false;
  completedIsActive: boolean = false;
  cancelledIsActive: boolean = false;
  overspent = false;
  filterCount:any;
  total_filter_count= 0;
  module_status_filters:any = []
  financeApproval = false;
  overspent_count:any;
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private titleService: Title,
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private snackBar: MatSnackBar
  ) {
    // sessionStorage.clear();
    this.showComponentLoader = true
    this.titleService.setTitle('AutomateLeads - Campaigns');
  }

  ngOnInit() {
    this.allSaleCampaign()
    //sessionStorage.clear();
  }


  allSaleCampaign() {

    let body = {}

    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch
    }

    if (this.campaign_status != undefined && this.campaign_status != "" && this.campaign_status != "Overspent") {
      body["status"] = this.campaign_status
    }

    if (this.finance_approved != undefined && this.finance_approved != '') {
      body["finance_approved"] = this.finance_approved
    }

    if (this.campaign_type != undefined && this.campaign_type != "") {
      body["campaign_type"] = this.campaign_type
    }

    if (this.client_type != undefined && this.client_type != "") {
      body["client_type"] = this.client_type
    }

    if (this.created_by != undefined && this.created_by != "") {
      body["created_by"] = this.created_by
    }

    if (this.marketing_manager != undefined && this.marketing_manager != "") {
      body["marketing_manager_id"] = this.marketing_manager
    }

    if (this.account_manager != undefined && this.account_manager != "") {
      body["account_manager_id"] = this.account_manager
    }

    if (this.assigned_user != undefined && this.assigned_user != "") {
      body["assigned_user_id"] = this.assigned_user
    }

    if (this.saleCity != undefined && this.saleCity != "") {
      body["sales_city"] = this.saleCity
    }

    if (this.sale_person != undefined && this.sale_person != "") {
      body["sales_manager_id"] = this.sale_person
    }

    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
    }

    if (this.assignedToMe) {
      body["assigned_to_me"] = this.assignedToMe
    }
    if (this.module_status_filters) {
      body["module_status_filters"] = this.module_status_filters
    }
    if(this.financeApproval){
    body['finance_approved_at'] = this.financeApproval
    }

    if(this.overspent){
      body['overspent'] = true
    }
    this.pageIndex = 0;
    this.pageSize = 50;

    this.showComponentLoader = true;

    this.url = "campaign_module/campaign/index_with_filters?per_page=" + this.pageSize + "&page=" + this.pageIndex;

    this.serverService.campaignListByFilter(this.url, body, this.authToken).subscribe(
      data => {
        this.project = data;
        //console.log(this.project)
        this.filterCount = data.campaigns_status_count;
        this.overspent_count = data.overspent_count
        // console.log(this.overspent_count)
        this.calculateTotalCount()
        
        this.lenCount = data.campaigns.length;
        //console.log(this.lenCount)

        this.showComponentLoader = false
      },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }
  fApproved(event:any){
    this.allSaleCampaign();
    // console.log(event)
  }
  getNext(event) {

    this.showComponentLoader = true

    let body1 = {
      "per_page": event.pageSize,
      "page": event.pageIndex
    };

    let body = {}

    this.pageSize = body1.per_page;
    this.pageIndex = body1.page
    let indexPage = this.pageIndex + 1

    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch
    }

    if (this.campaign_status != undefined && this.campaign_status != "" && this.campaign_status != "Overspent") {
      body["status"] = this.campaign_status
    }

    if (this.finance_approved != undefined && this.finance_approved != '') {
      body["finance_approved"] = this.finance_approved
    }

    if (this.campaign_type != undefined && this.campaign_type != "") {
      body["campaign_type"] = this.campaign_type
    }

    if (this.client_type != undefined && this.client_type != "") {
      body["client_type"] = this.client_type
    }

    if (this.created_by != undefined && this.created_by != "") {
      body["created_by"] = this.created_by
    }

    if (this.marketing_manager != undefined && this.marketing_manager != "") {
      body["marketing_manager_id"] = this.marketing_manager
    }

    if (this.account_manager != undefined && this.account_manager != "") {
      body["account_manager_id"] = this.account_manager
    }

    if (this.assigned_user != undefined && this.assigned_user != "") {
      body["assigned_user_id"] = this.assigned_user
    }

    if (this.saleCity != undefined && this.saleCity != "") {
      body["sales_city"] = this.saleCity
    }

    if (this.sale_person != undefined && this.sale_person != "") {
      body["sales_manager_id"] = this.sale_person
    }

    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
    }

    if (this.assignedToMe) {
      body["assigned_to_me"] = this.assignedToMe
    }
    
    if (this.module_status_filters) {
      body["module_status_filters"] = this.module_status_filters
    }
    if(this.financeApproval){
      body['finance_approved_at'] = this.financeApproval
      }
      if(this.overspent){
        body['overspent'] = true
      }
    // console.log(body)
    // this.module_status_filters

    this.url = "campaign_module/campaign/index_with_filters?per_page=" + this.pageSize + "&page=" + indexPage;

    this.serverService.campaignListByFilter(this.url, body, this.authToken).subscribe(data => {
      this.project = data
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }


  quickFilter(campaignStatus: any) {

    this.allIsActive = false;
    this.initialIsActive = false;
    this.inprogressIsActive = false;
    this.onholdlIsActive = false;
    this.liveIsActive = false;
    this.completedIsActive = false;
    this.cancelledIsActive = false;
    this.overspent = false

    if (campaignStatus == '') {
      this.allIsActive = true;
    }

    if (campaignStatus == 'Initial') {
      this.initialIsActive = true;
    }

    if (campaignStatus == 'In Progress') {
      this.inprogressIsActive = true;
    }

    if (campaignStatus == 'On Hold') {
      this.onholdlIsActive = true;
    }

    if (campaignStatus == 'Live') {
      this.liveIsActive = true;
    }

    if (campaignStatus == 'Completed') {
      this.completedIsActive = true;
    }

    if (campaignStatus == 'Cancelled') {
      this.cancelledIsActive = true;
    }
    if (campaignStatus == 'Overspent') {
      this.overspent = true;
    }
    
    



    let body = {};

    if (campaignStatus != null || campaignStatus != undefined) {
      this.campaign_status = campaignStatus
      body["status"] = this.campaign_status
      this.allSaleCampaign()
    } else {
      this.allSaleCampaign()
    }
  }

  filter(campaignStatus?: any) {

    let body = {};

    if (this.campaign_status != undefined && this.campaign_status != "") {
      body["status"] = this.campaign_status
    }

    if (this.finance_approved != undefined && this.finance_approved != '') {
      body["finance_approved"] = this.finance_approved
    }

    if (this.campaign_type != undefined && this.campaign_type != "") {
      body["campaign_type"] = this.campaign_type
    }

    if (this.client_type != undefined && this.client_type != "") {
      body["client_type"] = this.client_type
    }

    if (this.created_by != undefined && this.created_by != "") {
      body["created_by"] = this.created_by
    }

    if (this.marketing_manager != undefined && this.marketing_manager != "") {
      body["marketing_manager_id"] = this.marketing_manager
    }

    if (this.account_manager != undefined && this.account_manager != "") {
      body["account_manager_id"] = this.account_manager
    }

    if (this.assigned_user != undefined && this.assigned_user != "") {
      body["assigned_user_id"] = this.assigned_user
    }

    if (this.saleCity != undefined && this.saleCity != "") {
      body["sales_city"] = this.saleCity
    }

    if (this.sale_person != undefined && this.sale_person != "") {
      body["sales_manager_id"] = this.sale_person
    }

    if (this.createdAt != undefined && this.createdAt != "") {
      //body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
      body["createdAt"] = this.createdAt
    }

    if (this.assignedToMe) {
      body["assigned_to_me"] = this.assignedToMe
    }
    // console.log(this.module_status_filters)
    if(this.module_status_filters){
      body["module_status_filters"] = this.module_status_filters
    }
    if(this.overspent){
      body['overspent'] = true
    }
    this.campaignFilterModalComponent = this.dialog.open(CampaignFilterModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '600px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: body
    });
    this.campaignFilterModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        //console.log(result)

        this.allIsActive = true;
        this.initialIsActive = false;
        this.inprogressIsActive = false;
        this.onholdlIsActive = false;
        this.liveIsActive = false;
        this.completedIsActive = false;
        this.cancelledIsActive = false;
        this.overspent = false;

        this.showComponentLoader = true

        if (result.campaign_status != undefined && result.campaign_status != "") {
          this.campaign_status = result.campaign_status
        } else {
          this.campaign_status = ""
        }

        if (result.campaign_type != undefined && result.campaign_type != "") {
          this.campaign_type = result.campaign_type
        } else {
          this.campaign_type = ""
        }

        if (result.client_type != undefined && result.client_type != "") {
          this.client_type = result.client_type
        } else {
          this.client_type = ""
        }

        if (result.created_by != undefined && result.created_by != "") {
          this.created_by = result.created_by
        } else {
          this.created_by = ""
        }

        if (result.marketing_manager_id != undefined && result.marketing_manager_id != "") {
          this.marketing_manager = result.marketing_manager_id
        } else {
          this.marketing_manager = ""
        }

        if (result.account_manager_id != undefined && result.account_manager_id != "") {
          this.account_manager = result.account_manager_id
        } else {
          this.account_manager = ""
        }

        if (result.sales_city != undefined && result.sales_city != "") {
          this.saleCity = result.sales_city
        } else {
          this.saleCity = ""
        }

        if (result.sales_manager_id != undefined && result.sales_manager_id != "") {
          this.sale_person = result.sales_manager_id
        } else {
          this.sale_person = ""
        }

        if (result.assigned_user_id != undefined && result.assigned_user_id != "") {
          this.assigned_user = result.assigned_user_id
        } else {
          this.assigned_user = ""
        }

        if (result.createdAt != undefined && result.createdAt != "") {
          this.createdAt = result.createdAt
        } else {
          this.createdAt = ""
        }

        if (result.assigned_to_me) {
          this.assignedToMe = result.assigned_to_me
        } else {
          this.assignedToMe = false
        }
        // console.log(result)
        if(result.module_status_filters){
          this.module_status_filters = result.module_status_filters;
        }

        this.finance_approved = result.finance_approved

        this.allIsActive = true;
        this.initialIsActive = false;
        this.inprogressIsActive = false;
        this.onholdlIsActive = false;
        this.liveIsActive = false;
        this.completedIsActive = false;
        this.cancelledIsActive = false;
        this.overspent = false;

        this.allSaleCampaign()
      }
    })
  }

  create() {
    this.saleCampaignCreateModalComponent = this.dialog.open(SaleCampaignCreateModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '800px',
      panelClass: 'cdk-overlay-panel-right-side'
    });
    this.saleCampaignCreateModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        setTimeout(() => { // default task taking time (instant not showing)
          this.allSaleCampaign()
        }, 5000);
      }
    })
  }

  openProjectCreateModal(project: any) {
    this.saleCampaignProjectCreateModalComponent = this.dialog.open(SaleCampaignProjectCreateModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '50vw',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.saleCampaignProjectCreateModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign()
      }
    })
  }

  edit(project) {

    this.saleCampaignEditModalComponent = this.dialog.open(SaleCampaignEditModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '800px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.saleCampaignEditModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign();
      }
    })
  }

  removeSearch() {
    this.elasticSearch = ""
    this.allSaleCampaign()
  }

  openClientCreateModal(project) {
    this.saleCampaignClientCreateModalComponent = this.dialog.open(SaleCampaignClientCreateModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '500px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.saleCampaignClientCreateModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign()
        this.openClientDialog(result)
      }
    })
  }

  openClientDialog(element) {
    //console.log(element)
    this.vendorAssignModelComponent = this.dialog.open(VendorAssignModelComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '500px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: element
    });
  }

  updateCampaignStatus(data: any, status) {

    let body = {
      'status': status
      // 'delivery_manager_id': this.project.spAm,
      // 'marketing_manager_id': this.project.spAm,
      // 'client_type': this.project.clientType,  
      // 'client_name': this.project.clientName,
      // 'client_number': this.project.clientEmail,
      // 'city': this.project.city,
      // 'client_rera': this.project.clientRera,  
      // 'project_name': this.project.projectName,
      // 'project_type': this.project.projectType,
      // 'project_address': this.project.location,
      // 'latitude': this.project.latitude,
      // 'longitude': this.project.longitude,  
      // 'min_price': this.project.price,
      // 'project_configuration': this.project.configuration,
      // 'project_status': this.project.projectStatus,  
      // 'possession': this.project.possession,
      // 'rera_number': this.project.reraId,  
      // 'campaign_type': this.project.campaignType,
      // 'duration': this.project.duration,
      // 'no_of_leads': this.project.noOfLeads,  
      // 'mode_of_delivery': this.project,
      // 'mode_of_notification': this.project,  
      // 'offers': this.project,
      // 'media_plan': this.project,  
    }

    this.showComponentLoader = true;
    this.serverService.editSaleCampaign(data.id, body, this.authToken).subscribe(data => {
      // console.log(data);
      this.showComponentLoader = false;
      this.clipBoardService.showMessgeInText('Campaign Update Successfully', 'success-snackbar')
      this.allSaleCampaign();
    }, err => {
      this.showComponentLoader = false;
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }

  goToDetail(data: any) {
    // this.router.navigate([,'_blank'])
    this.router.navigate([]).then(result => { window.open('page/campaign-details/' + data.id, '_blank'); });
  }

  confirmCampaignStatus(campaignId: any, status: any) {

    let statusesandCampaignId = {
      campaignId: campaignId,
      status: status,
    };

    this.campaignStatusComponent = this.dialog.open(CampaignStatusComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "500px",
      data: statusesandCampaignId,
    });
    this.campaignStatusComponent.afterClosed().subscribe((result) => {
      // console.log(result)
      if (result != undefined) {
        this.allSaleCampaign();
      }
    });
  }

  openLeadDeliveryModal(project) {
    this.addLeadDeliveredComponent = this.dialog.open(AddLeadDeliveredComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '85vw',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.addLeadDeliveredComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign()
      }
    })
  }

  openLeadDeliveryListModal(project) {
    this.leadDeliveryListComponent = this.dialog.open(LeadDeliveryListComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '900px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.leadDeliveryListComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign()
      }
    })
  }

  openAddAmountSpentModal(project) {
    this.addAmountSpentComponent = this.dialog.open(AddAmountSpentComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '85vw',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.addAmountSpentComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign()
      }
    })
  }

  openSpentListModal(project) {
    this.amountSpentListComponent = this.dialog.open(AmountSpentListComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '900px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.amountSpentListComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign()
      }
    })
  }

  openAddBudgetModal(project) {
    this.addBudgetComponent = this.dialog.open(AddBudgetComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '1250px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.addBudgetComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign()
      }
    })
  }

  openAddBudgetListModal(project) {
    this.budgetListComponent = this.dialog.open(BudgetListComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '1020px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.budgetListComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign()
      }
    })
  }

  openAddFeedbackModal(project) {
    this.addFeedbackComponent = this.dialog.open(AddFeedbackComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "100vw",
      maxWidth: "97vw",
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.addFeedbackComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign()
      }
    })
  }


  openFeedbackListModal(project) {
    this.feedbackListModalComponent = this.dialog.open(FeedbackListModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '1020px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.feedbackListModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign()
      }
    })
  }

  openRaiseEscalationModal(project) {
    this.raiseEscalationComponent = this.dialog.open(RaiseEscalationComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '1020px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.raiseEscalationComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allSaleCampaign()
      }
    })
  }

  // openEscalationUpdateModal(project) {
  //   this.escalationStatusModalComponent = this.dialog.open(EscalationStatusModalComponent, {
  //     hasBackdrop: true,
  //     disableClose: false,
  //     autoFocus: true,
  //     width: '1020px',
  //     panelClass: 'cdk-overlay-panel-right-side',
  //     data: project
  //   });
  //   this.escalationStatusModalComponent.afterClosed().subscribe(result => {
  //     if (result != undefined) {
  //       this.showComponentLoader = true
  //       this.allSaleCampaign()
  //     }
  //   })
  // }


  openProjectListDialog(projects:any): void {
   this.projectListModalComponent =  this.dialog.open(ProjectListModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      panelClass: 'cdk-overlay-panel-right-side',
      width: '350px',
      data: projects
    });    
  }

  calculateTotalCount() {
    this.total_filter_count = 
      (this.filterCount.Initial || 0) +
      (this.filterCount['In Progress'] || 0) +
      (this.filterCount['On Hold'] || 0) +
      (this.filterCount.Live || 0) +
      (this.filterCount.Completed || 0) +
      (this.filterCount.Cancelled || 0);
  }
}
